import React from 'react';

import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import MenuSeparator from './MenuSeparator';

import { removeItem } from 'utils/localstorage'
import { LOCALSTORAGE_KEY } from 'utils/constants'
import Logo from 'assets/iso-logo.png'
import './SideMenu.css'
import SideMenuTitle from './SideMenuTitle';

function SideMenu(props) {
	const { location, history, setLoggedIn, menuExpanded, setMenuExpanded } = props

	const onToggle = (isExpanded) => {
		setMenuExpanded(isExpanded)
	}

	const handleLogOut = () => {
		setLoggedIn(false);
		removeItem(LOCALSTORAGE_KEY);
	}

	let selected = location.pathname.substring(1)
	if (selected === 'login' || selected === '') {
		selected = 'inicio'
	}

	return (
		<SideNav expanded={menuExpanded} onToggle={onToggle} id="sidenav"
			onSelect={(selected) => {
				const to = '/' + selected;
				if (location.pathname !== to) {
					history.push(to);
				}
			}}
		>
			<SideNav.Toggle />
			<div className="sidenavHeader">

			</div>
			<SideNav.Nav defaultSelected={selected}>
				<div className="sidenavLogo">
					<img src={Logo} alt="logo" />
				</div>
				<NavItem eventKey="inicio">
					<NavIcon>
						<i className="fa fa-fw fa-home" />
					</NavIcon>
					<NavText>
						Inicio
					</NavText>
				</NavItem>
				<MenuSeparator />
				<SideMenuTitle title="Portal Poha" icon="fa-cogs" menuExpanded={menuExpanded} />
				<NavItem eventKey="usuarios">
					<NavIcon>
						<i className="fas fa-users" />
					</NavIcon>
					<NavText>
						Usuarios <div className="submenu-nav"><i className="fa fa-caret-down expand"></i> <i className="fa fa-caret-up collapse"></i></div>
					</NavText>
					<NavItem eventKey="usuarios/administradores">
						<NavText title="Administradores">
							Administradores
						</NavText>
					</NavItem>
					<NavItem eventKey="usuarios/clientes">
						<NavText title="Clientes">
							Clientes
						</NavText>
					</NavItem>
				</NavItem>
				<NavItem eventKey="wiki">
					<NavIcon>
						<i className="fa fa-book" />
					</NavIcon>
					<NavText>
						Wiki
					</NavText>
				</NavItem>
				<NavItem eventKey="investigacion">
					<NavIcon>
						<i className="fa fa-microscope" />
					</NavIcon>
					<NavText>
						Investigaciones científicas
					</NavText>
				</NavItem>
				<NavItem eventKey="noticias">
					<NavIcon>
						<i className="fa fa-newspaper" />
					</NavIcon>
					<NavText>
						Noticias
					</NavText>
				</NavItem>
				<NavItem eventKey="modificaciones">
					<NavIcon>
						<i className="fa fa-pen-to-square" />
					</NavIcon>
					<NavText>
						Editar contenido <div className="submenu-nav"><i className="fa fa-caret-down expand"></i> <i className="fa fa-caret-up collapse"></i></div>
					</NavText>
					<NavItem eventKey="modificaciones/portal-inicio">
						<NavText title="Inicio">
							Inicio
						</NavText>
					</NavItem>
					<NavItem eventKey="modificaciones/portal-nosotros">
						<NavText title="Nosotros">
							Nosotros
						</NavText>
					</NavItem>
				</NavItem>
				<MenuSeparator />
				<SideMenuTitle title="Sitio Web" icon="fa-globe" menuExpanded={menuExpanded} />
				<NavItem eventKey="ejes">
					<NavIcon>
						<i className="fa-solid fa-building-columns" />
					</NavIcon>
					<NavText>
						Ejes
					</NavText>
				</NavItem>
				<NavItem eventKey="informacion-publica">
					<NavIcon>
						<i className="fa-solid fa-info-circle" />
					</NavIcon>
					<NavText>
						Información pública
					</NavText>
				</NavItem>
				<NavItem eventKey="galeria">
					<NavIcon>
						<i className="fa-solid fa-image" />
					</NavIcon>
					<NavText>
						Galería
					</NavText>
				</NavItem>
				<NavItem eventKey="modificaciones">
					<NavIcon>
						<i className="fa fa-pen-to-square" />
					</NavIcon>
					<NavText>
						Editar contenido <div className="submenu-nav"><i className="fa fa-caret-down expand"></i> <i className="fa fa-caret-up collapse"></i></div>
					</NavText>
					<NavItem eventKey="modificaciones/inicio">
						<NavText title="Inicio">
							Inicio
						</NavText>
					</NavItem>
					<NavItem eventKey="modificaciones/nosotros">
						<NavText title="Nosotros">
							Nosotros
						</NavText>
					</NavItem>
					<NavItem eventKey="modificaciones/escuelas">
						<NavText title="Escuelas">
							Escuelas
						</NavText>
					</NavItem>
					<NavItem eventKey="modificaciones/radio">
						<NavText title="Radio">
							Radio
						</NavText>
					</NavItem>
					<NavItem eventKey="modificaciones/contacto">
						<NavText title="Contacto">
							Contacto
						</NavText>
					</NavItem>
				</NavItem>
				<MenuSeparator />
				<NavItem eventKey="logout" onClick={handleLogOut}>
					<NavIcon>
						<i className="fa fa-fw fa-power-off" style={{ fontSize: '1.5em' }} />
					</NavIcon>
					<NavText style={{ paddingRight: 32 }} title="Cerrar">
						Cerrar
					</NavText>
				</NavItem>
			</SideNav.Nav>
		</SideNav>
	)
}

export default SideMenu